export const getSalaryDetails = (
  minimumSalary: any,
  maximumSalary: any,
  SITE_CONTEXT: string,
): string => {
  if (!minimumSalary || !maximumSalary) return "";

  const formatStringWithCommas = (strText: string): string => {
    return strText.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const getSalaryRange = (
    currency: string,
    minSalary: string,
    maxSalary: string,
    currencySuffix: string,
  ): string => {
    return `${formatStringWithCommas(minSalary)} - ${formatStringWithCommas(maxSalary)} ${currencySuffix}`;
  };

  const LAKH = 100000;

  const {
    absoluteMonthlyValue: minMonthlyValue,
    absoluteValue: minAbsoluteValue,
    currency = "",
  } = minimumSalary || {};

  const {
    absoluteMonthlyValue: maxMonthlyValue,
    absoluteValue: maxAbsoluteValue,
  } = maximumSalary || {};

  if (
    minAbsoluteValue &&
    minAbsoluteValue !== 0 &&
    maxAbsoluteValue &&
    maxAbsoluteValue !== 0 &&
    SITE_CONTEXT === "rexmonster"
  ) {
    if (currency === "INR") {
      const lowerLPA = (minAbsoluteValue / LAKH).toFixed(2);
      const upperLPA = (maxAbsoluteValue / LAKH).toFixed(2);
      return getSalaryRange(
        currency,
        lowerLPA.toString(),
        upperLPA.toString(),
        "LPA",
      );
    }

    return getSalaryRange(
      currency,
      minAbsoluteValue.toLocaleString(),
      maxAbsoluteValue.toLocaleString(),
      "mth",
    );
  }

  if (
    minMonthlyValue &&
    minMonthlyValue !== 0 &&
    maxMonthlyValue &&
    maxMonthlyValue !== 0
  ) {
    return getSalaryRange(
      currency,
      minMonthlyValue.toString(),
      maxMonthlyValue.toString(),
      "mth",
    );
  }

  return "";
};

export const currencySymbolMap: { [key: string]: string } = {
  AED: "د.إ",
  AFN: "؋",
  ALL: "L",
  AMD: "֏",
  ANG: "ƒ",
  AOA: "Kz",
  ARS: "$",
  AUD: "A$",
  AWG: "ƒ",
  AZN: "₼",
  BAM: "KM",
  BBD: "Bds$",
  BDT: "৳",
  BGN: "лв",
  BHD: ".د.ب",
  BIF: "FBu",
  BMD: "$",
  BND: "B$",
  BOB: "Bs.",
  BRL: "R$",
  BSD: "B$",
  BTN: "Nu.",
  BWP: "P",
  BYN: "Br",
  BZD: "BZ$",
  CAD: "C$",
  CDF: "FC",
  CHF: "CHF",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  CRC: "₡",
  CUP: "$",
  CVE: "$",
  CZK: "Kč",
  DJF: "Fdj",
  DKK: "kr",
  DOP: "RD$",
  DZD: "د.ج",
  EGP: "E£",
  ERN: "Nfk",
  ETB: "Br",
  EUR: "€",
  FJD: "FJ$",
  FKP: "£",
  GBP: "£",
  GEL: "₾",
  GGP: "£",
  GHS: "GH₵",
  GIP: "£",
  GMD: "D",
  GNF: "FG",
  GTQ: "Q",
  GYD: "GY$",
  HKD: "HK$",
  HNL: "L",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  IMP: "£",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "kr",
  JEP: "£",
  JMD: "J$",
  JOD: "JD",
  JPY: "¥",
  KES: "KSh",
  KGS: "лв",
  KHR: "៛",
  KMF: "CF",
  KPW: "₩",
  KRW: "₩",
  KWD: "KD",
  KYD: "$",
  KZT: "₸",
  LAK: "₭",
  LBP: "ل.ل",
  LKR: "Rs",
  LRD: "$",
  LSL: "M",
  LYD: "LD",
  MAD: "د.م.",
  MDL: "L",
  MGA: "Ar",
  MKD: "ден",
  MMK: "K",
  MNT: "₮",
  MOP: "MOP$",
  MRO: "UM",
  MRU: "UM",
  MUR: "₨",
  MVR: "Rf",
  MWK: "MK",
  MXN: "$",
  MYR: "RM",
  MZN: "MT",
  NAD: "$",
  NGN: "₦",
  NIO: "C$",
  NOK: "kr",
  NPR: "रू",
  NZD: "NZ$",
  OMR: "ر.ع.",
  PAB: "B/.",
  PEN: "S/",
  PGK: "K",
  PHP: "₱",
  PKR: "₨",
  PLN: "zł",
  PYG: "₲",
  QAR: "ر.ق",
  RON: "lei",
  RSD: "дин.",
  RUB: "₽",
  RWF: "RF",
  SAR: "ر.س",
  SBD: "SI$",
  SCR: "₨",
  SDG: "ج.س.",
  SEK: "kr",
  SGD: "S$",
  SHP: "£",
  SLL: "Le",
  SOS: "Sh",
  SRD: "$",
  SSP: "£",
  STD: "Db",
  STN: "Db",
  SYP: "£",
  SZL: "E",
  THB: "฿",
  TJS: "SM",
  TMT: "T",
  TND: "د.ت",
  TOP: "T$",
  TRY: "₺",
  TTD: "TT$",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  USD: "$",
  UYU: "$U",
  UZS: "so'm",
  VEF: "Bs",
  VES: "Bs.",
  VND: "₫",
  VUV: "VT",
  WST: "T",
  XAF: "FCFA",
  XCD: "$",
  XOF: "CFA",
  XPF: "₣",
  YER: "﷼",
  ZAR: "R",
  ZMW: "ZK",
  ZWL: "Z$",
};
